import { Transition } from '@headlessui/react'
import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Menu } from 'heroicons-react'

const MyNavButtonActions = ({ onClick, textBtn }) => {
  return (
    <>
      <div className="flex items-center">
        <Menu as="div" className="relative inline-block text-left">
          <div>
            <button
              className={
                'inline-flex w-full justify-center rounded-md bg-blue-700 px-4 py-2 text-sm font-medium text-white' +
                ' shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2' +
                ' focus:ring-offset-blue-100 hover:bg-blue-500'
              }
              type="button"
            >
              {textBtn}
              <svg
                aria-hidden="true"
                className="-mr-1 ml-2 h-5 w-5"
                fill="#fff"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d={
                    'M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0' +
                    ' 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
                  }
                />
              </svg>
            </button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              className={
                'absolute right-0 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg' +
                ' ring-1 ring-black ring-opacity-5 focus:outline-none'
              }
            >
              <Menu.Item>
                <button
                  className={
                    'block h-full w-full px-4 py-2 text-left text-sm text-slate-700' +
                    ' hover:font-bold hover:text-slate-900'
                  }
                  onClick={onClick}
                  type="button"
                >
                  Nuevo
                </button>
              </Menu.Item>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
    </>
  )
}

export default MyNavButtonActions

MyNavButtonActions.propTypes = {
  onClick: PropTypes.func,
  textBtn: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}
